import {
    isObject,
    isString,
    ajaxSend,
    deepClone,
    isFunction,
    deepMixin,
    http_build_query
} from "../../funcs";
import $ from "jquery";
import Events from "../Events";
import ApiError from "../Error/ApiError";
import "../../plugins/jquery.cookie";

/**
 * @typedef RequestParams
 * @type {object}
 * @property {"customlogic"|"api"} root - корень url
 * @property {string} entity - если customlogic, то это имя папки в /app/modules${entity}
 * @property {string} method - если customlogic, то это имя файла в /app/modules/${entity}/logic/${method}.(js|ts)
 * @property {object} data - данные, который попадает в req.app.data
 */
/**
 * @typedef ApiResponse
 * @type {object}
 * @property {*} result - ответ от сервера
 * @property {string} status - статус ответа
 */

// записываем все запросы и ответы

// абсолютно все запросы должны проходить через эту функцию
// работет по спецификации Api 1.0
let request = function(params, callback) {
    params = deepClone(params);
    params.stack = new Error().stack;

    if ( !isFunction(callback) ) {
        callback = function() {
        };
    }

    let onResponse = this.onResponse || Api.onResponse;
    onResponse = onResponse.bind(this, params, function(/* err, result, response */) {
        callback.apply(this, arguments);
    });

    if ( !("root" in params) ) {
        params.root = "/api";
    }

    let url = params.root + "/" + params.entity;
    if ( !params.rest ) {
        url += "/";
        url += params.method;
    }

    if ( "target" in params && params.target ) {
        url += "/";
        url += params.target;
    }

    let postData = {
        json: JSON.stringify(params.data)
    };

    if ( "config" in params ) {
        postData.jsonConfig = JSON.stringify(params.config);
    }

    //Режим оценки производительности API
    //Добавляет к ответу API дополнительную отладочную информацию в объекте response.stats
    //response.stats.processingTime время с момента срабатывания обработчика запроса до apiReply
    if ( this.benchmark ) {
        postData.benchmark = JSON.stringify(true);
    }

    if ( isObject(params.query) ) {
        url += "?";
        url += http_build_query(params.query);
    }

    let headers = deepMixin({
        Autorization: $.cookie("token")
    }, params.headers);

    if ( "files" in params ) {
        postData.files = params.files;
        ajaxSend({
            method: "POST",
            url,
            data: postData,
            onResponse,
            headers
        });
    } else {

        $.ajax({
            headers,
            method: params.rest ? params.method : "POST",
            url,
            data: postData,
            success: onResponse,
            error: Api.onError.bind(Api, onResponse, params)
        });
    }
};

export default class Api extends Events {

    /**
     * Чаще всего используем для вызова особой функции из app/modules
     * @param {RequestParams} params - параметры запроса
     * @param {Function} [callback] - callbak функция
     * @returns {Promise<ApiResponse>}
     */
    static async request(params, callback) {
        if ( isFunction(callback) ) {
            request.call(Api, params, callback);
        } else {
            return new Promise((resolve, reject) => {
                request.call(Api, params, (err, response) => {
                    if ( err ) {
                        reject(err);
                    } else {
                        resolve(response);
                    }
                });
            });
        }
    }

    static onError(callback, params, $response) {
        let response;

        if ( $response.status === 413 ) {
            response = {
                result: {
                    status: "error",
                    code: "payload_too_large"
                }
            };
        } else {
            response = {
                result: {
                    status: "error",
                    code: "ajax_error"
                }
            };
        }

        switch ($response.status) {
            case 401: {
                break;
            }

            default:
                callback(response);
                break;
        }
    }

    static onResponse(request, callback, response) {
        if ( isObject(response) && isString(response.responseText) ) {
            response = response.responseText;
        }
        if ( isString(response) ) {
            try {
                response = JSON.parse(response);
            } catch (e) {
                console.error(e);
            }
        }


        if ( !isObject(response) ) {
            response = {};
        }
        if ( !isObject(response.result) ) {
            response.result = {};
        }

        let err = null;
        let status = response.result.status;
        if ( status != "success" && status != "Blocked" && status != "Unblocked" && request.showError !== false ) {
            err = new ApiError({ response, request });
        }

        return callback(err, response.result, response);
    }

    _request(params, callback) {
        let request = this.constructor.request || Api.request;

        params.root = "/api";
        params.entity = params.entity || this._entity;
        return request.call(this.constructor, params, callback);
    }
}
